var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReload = function SvgReload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m20.116 10.285 1.11-7.703-1.236-.179-.785 5.439a8.877 8.877 0 0 0-15.684 8.22 8.875 8.875 0 0 0 16.05.438l-1.117-.563a7.625 7.625 0 1 1-.16-7.177l-5.703-.823-.179 1.237 7.704 1.111Z",
    fill: "currentColor"
  })));
};
export default SvgReload;